module.exports = __webpack_public_path__ + "img/laurel-front-angle.33674acd.png";